module.exports = __webpack_public_path__ + "static/index/img/baikal-806.5e48cb3c.jpg";